import React, { useState } from 'react';
import Calendar from 'react-calendar';
import './CalendarComponent.css'; // Import CSS file

// import {Calendar} from "@natscale/react-calendar"; // Correct import statement

function CalendarComponent({ onDateChange }) {
  const [date, setDate] = useState(new Date());
  const today = new Date();

  const handleDateChange = (selectedDate) => {
    setDate(selectedDate);
    onDateChange(selectedDate);
  };

  const isDateToday = (date) => {
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  const tileClassName = ({ date }) => {
    if (isDateToday(date)) {
      return 'highlighted';
    }
    return '';
  };

  return (
    <div className='flex justify-center w-full p-3 mx-auto shadow-lg hover:shadow-xl xs:mt-10 bg-slate-50 rounded-xl '>
      {/* <h2>Calendar</h2> */}
      <Calendar
        onChange={handleDateChange}
        value={date}
        tileClassName={tileClassName}
      />
            {/* <Calendar value={date} onChange={handleDateChange} tileClassName={tileClassName}/> */}

    </div>
  );
}

export default CalendarComponent;
